const FailuresDashboard = {
  namespaced: true,

  state: {
    date: null,

  },
  mutations:{
    setDate(state, val){
      state.date = val;
    }
  },
  actions : {
    setDate(ctx, val){
      ctx.commit('setDate', val);
    }
  },


  getters: {
    getDate: state => state.date
  }
};

export default FailuresDashboard;